/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import SmartContext from './SmartContext';
import {
  TEACHER_ROOM_OPTION_TYPE,
  UPLOAD_STATUS,
} from '../../../shared/utils/constants';
import {
  createVimeoVideoUpload,
  createTusUploadObject,
} from '../../../shared/services/VimeoUploadService';

const SmartProvider = (props) => {
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [currentTusUpload, setCurrentTusUpload] = useState();
  const [loggedUser, setLoggedUser] = useState({});
  const [listOfPermission, setlistOfPermission] = useState({});
  const [listOfOperation, setListOfOperation] = useState({});
  const [logginOut, setLogginOut] = useState(false);
  const [pendencySummary, setPendencySummary] = useState({
    smartGoPendency: 0,
    totalMedicalPendencyQuantity: 0,
    lateMedicalPendencyQuantity: 0,
    unreadChatMessages: 0,
    communicationPendency: 0,
    routineRecordsPendency: 0,
    chatSummary: [],
  });
  const [filterAccountsReceivableAndPayable, setAccountsReceivableAndPayable] =
    useState();

  const [postsFilter, setPostsFilter] = useState();
  const [survey, setSurvey] = useState();
  const [teacherRoomMemoBox, setTeacherRoomMemoBox] = useState(
    TEACHER_ROOM_OPTION_TYPE.GRADE
  );

  const updateFile = async (fileToUpdate) => {
    const currentFilesToUpload = [...filesToUpload];
    const fileIndexToUpdate = currentFilesToUpload.findIndex((file) => {
      return file.content.id === fileToUpdate.content.id;
    });
    currentFilesToUpload[fileIndexToUpdate] = fileToUpdate;
    setFilesToUpload(currentFilesToUpload);
  };

  const getCurrentFileUploading = () => {
    const currentFileUploading = filesToUpload.find(
      (file) => file.status === UPLOAD_STATUS.UPLOADING
    );
    return currentFileUploading;
  };

  const getSlicesToUploadFile = (size) => {
    const chunkSize = 10485760;
    const chunksLength = Math.round(size / chunkSize);
    const arrayOfChunks = [];
    let byteIndex = 0;
    if (size < chunkSize) {
      arrayOfChunks.push({
        id: 0,
        start: 0,
        end: size,
        done: false,
        progress: 0,
      });
      return arrayOfChunks;
    }
    for (let i = 0; i < chunksLength; i += 1) {
      const byteEnd = chunkSize * (i + 1);
      arrayOfChunks.push({
        id: i,
        start: byteIndex,
        end: byteEnd,
        done: false,
        progress: 0,
      });
      byteIndex += byteEnd - byteIndex;
    }
    return arrayOfChunks;
  };

  const onUploadErrorHandler = async () => {
    const fileToSetError = getCurrentFileUploading();
    fileToSetError.status = UPLOAD_STATUS.ERROR;
    await updateFile(fileToSetError);
  };

  const onProgressUpload = async (bytesAcceptedProps, bytesTotalProps) => {
    const fileToSetProgress = getCurrentFileUploading();
    if (fileToSetProgress) {
      const { sliceIndex, slices } = fileToSetProgress.content;
      const totalAccepted = slices.reduce(
        (total, slice) => total + slice.progress,
        0
      );
      fileToSetProgress.content.slices[sliceIndex].progress =
        bytesAcceptedProps;
      fileToSetProgress.content.bytesAccepted = totalAccepted;
      fileToSetProgress.content.bytesTotal = bytesTotalProps;
      await updateFile(fileToSetProgress);
    }
  };

  const onChunckComplete = async (bytesAcceptedProps) => {
    const fileToSetChunckComplete = getCurrentFileUploading();
    if (fileToSetChunckComplete) {
      const { slices } = fileToSetChunckComplete.content;
      const totalSlices = slices.length - 1;
      const totalAccepted = slices.reduce(
        (total, slice) => total + slice.progress,
        0
      );
      let { sliceIndex } = fileToSetChunckComplete.content;
      slices[sliceIndex].progress = bytesAcceptedProps;
      slices[sliceIndex].done = true;
      fileToSetChunckComplete.content.bytesAccepted = totalAccepted;
      sliceIndex = sliceIndex < totalSlices ? (sliceIndex += 1) : totalSlices;
      fileToSetChunckComplete.content.sliceIndex = sliceIndex;
      updateFile(fileToSetChunckComplete);
    }
  };

  const onSuccessUpload = () => {
    const fileUploading = getCurrentFileUploading();
    fileUploading.status = UPLOAD_STATUS.DONE;
    updateFile(fileUploading);
  };

  const fingerprint = (file) => {
    return Promise.resolve(file.name);
  };

  const startUploadHandler = async (fileToStartUpload) => {
    const file = fileToStartUpload.content;
    if (file.uploadLink) {
      const tusConfig = {
        endpoint: 'https://us-files.tus.vimeo.com/files/vimeo-prod-src-tus-us/',
        uploadUrl: file.uploadLink,
        retryDelays: [0, 1000, 3000, 5000],
        chunkSize: 10485760,
        fingerprint,
        metadata: {
          filename: file.name || 'Smart',
          filetype: file.filetype,
        },
        onError: onUploadErrorHandler,
        onProgress: onProgressUpload,
        onChunkComplete: onChunckComplete,
        onSuccess: onSuccessUpload,
      };
      const tusUpload = await createTusUploadObject(file, tusConfig);
      setCurrentTusUpload(tusUpload);
      tusUpload.start();
    }
  };

  const createVimeoUploadLinks = async (file) => {
    const response = await createVimeoVideoUpload(file.content);
    return response;
  };

  const handleFileToUpload = async () => {
    const files = [...filesToUpload];
    const filesWithVimeoId = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const file of files) {
      // eslint-disable-next-line no-await-in-loop
      const uploadVimeoResponse = await createVimeoUploadLinks(file);
      const slices = getSlicesToUploadFile(file.content.size);
      if (uploadVimeoResponse) {
        file.status = UPLOAD_STATUS.UPLOADING;
        file.content.slices = slices;
        file.content.sliceIndex = 0;
        file.content.uploadLink = uploadVimeoResponse.upload.upload_link;
        file.content.fileId = String(/\d+/.exec(uploadVimeoResponse.uri));
        // eslint-disable-next-line no-await-in-loop
        await updateFile(file);
        startUploadHandler(file);
      } else {
        file.status = UPLOAD_STATUS.ERROR;
        file.content.slices = slices;
        file.content.sliceIndex = 0;
        // eslint-disable-next-line no-await-in-loop
        await updateFile(file);
      }
      filesWithVimeoId.push(file.content);
    }

    return filesWithVimeoId;
  };

  const cleanContext = () => {
    setFilesToUpload([]);
    setCurrentTusUpload();
    setLoggedUser({});
    setlistOfPermission({});
    setListOfOperation({});
    setLogginOut(false);
    setPendencySummary({
      smartGoPendency: 0,
      totalMedicalPendencyQuantity: 0,
      lateMedicalPendencyQuantity: 0,
      unreadChatMessages: 0,
      communicationPendency: 0,
      routineRecordsPendency: 0,
      chatSummary: [],
    });
    setAccountsReceivableAndPayable();
    setPostsFilter();
  };

  const removeFileByVimeoId = (vimeoId) => {
    const files = [...filesToUpload];
    const index = filesToUpload.findIndex(
      (file) => file.content.fileUrl === vimeoId
    );
    files.splice(index, 1);
    setFilesToUpload(files);
  };

  const { children } = props;
  return (
    <SmartContext.Provider
      value={{
        pendencySummary,
        filesToUpload,
        updatePendencySummary: (newValue) => {
          setPendencySummary(newValue);
        },
        addFile: (fileToAdd) => {
          const fileToAddIndex = filesToUpload.findIndex(
            (file) => file.content.id === fileToAdd.content.id
          );
          if (fileToAddIndex < 0) {
            filesToUpload.push(fileToAdd);
          }
          setFilesToUpload(filesToUpload);
        },
        removeFiles: (currentFilesSet) => {
          // Current file set, files present in filesToUpload and not present in currentFilesSet should be removed.
          const newFileSet = [];
          let found;
          for (let i = 0; i < filesToUpload.length; i += 1) {
            found = false;
            for (let j = 0; j < currentFilesSet.length; j += 1) {
              if (filesToUpload[i].content.id === currentFilesSet[j].id) {
                found = true;
                break;
              }
            }
            if (found) {
              newFileSet.push(filesToUpload[i]);
            }
          }
          setFilesToUpload(newFileSet);
        },
        updateFileToPauseUploadStatus: async (fileToUpdateStatus) => {
          const fileToSetPauseStatus = fileToUpdateStatus;
          await updateFile(fileToSetPauseStatus);
        },
        updateFileToUploadingUploadStatus: async (fileToUpdateStatus) => {
          const fileToSetUploadingeStatus = fileToUpdateStatus;
          await updateFile(fileToSetUploadingeStatus);
        },
        handlerFileToUploadWithTus: async () => {
          const uploadVimeoResponse = await handleFileToUpload();
          return uploadVimeoResponse;
        },
        haveFilesToUpload: () => {
          const listFilesPendingUpload = filesToUpload.filter((file) => {
            return file.status === UPLOAD_STATUS.PENDING;
          });
          if (listFilesPendingUpload.length) {
            return true;
          }
          return false;
        },
        removeFileByVimeoId,
        haveFilesUploading: () => {
          const listFilesPendingUpload = filesToUpload.findIndex((file) => {
            return file.status !== UPLOAD_STATUS.DONE;
          });
          if (listFilesPendingUpload > -1) {
            return true;
          }
          return false;
        },
        setLoggedUser: (user) => {
          setLoggedUser(user);
        },
        setlistOfPermission: (permissions) => {
          setlistOfPermission(permissions);
        },
        setListOfOperation: (operations) => {
          setListOfOperation(operations);
        },
        loggedUser,
        logginOut,
        listOfPermission,
        listOfOperation,
        filterAccountsReceivableAndPayable,
        toggleLoginOut: () => {
          setLogginOut(!logginOut);
        },
        setAccountsReceivableAndPayable,
        cleanContext,
        postsFilter,
        setPostsFilter,
        setSurvey: (surveyValue) => {
          setSurvey(surveyValue);
        },
        survey,
        setTeacherRoomMemoBox: (memo) => setTeacherRoomMemoBox(memo),
        teacherRoomMemoBox,
      }}
    >
      {children}
    </SmartContext.Provider>
  );
};

SmartProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

SmartProvider.defaultProps = {
  children: [],
};

export const useSmartContext = () => {
  const context = useContext(SmartContext);
  return context;
};

export default SmartProvider;
